import { USER_DATA } from "../apiEndpoint";
import { educationAxios } from "../http/http";

export default function userData(formData,email) {
    educationAxios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
  return educationAxios.post(USER_DATA+'?user_email='+ email ,formData);
}
